export const environment = {
    production: true,
    sentry: true,
    url_auth: '/carbon/v1/auth/',
    url_carbon: '/carbon/v1/',
};
